import {
  CostAllocationStrategy,
  ICostAllocation,
} from '@rygen/rygen-ui/model/costAllocation';

import { BillingShipmentReference } from './BillingShipmentReference';
import { ShipmentRateLineItemAllocation } from './ShipmentRateLineItemAllocation';

export class ShipmentRateAllocation implements ICostAllocation<ShipmentRateLineItemAllocation> {
  shipment?: BillingShipmentReference;
  strategy: CostAllocationStrategy =
    CostAllocationStrategy.SYSTEM_DEFAULT_STRATEGY;
  lineItems: ShipmentRateLineItemAllocation[] = [];

  constructor(opts?: Partial<ShipmentRateAllocation>) {
    if (opts?.shipment != null) {
      this.shipment = new BillingShipmentReference(opts?.shipment);
    }
    if (typeof opts?.strategy === 'string') {
      this.strategy = CostAllocationStrategy[opts.strategy];
    } else if (opts?.strategy != null) {
      this.strategy = opts.strategy;
    }
    if (opts?.lineItems != null) {
      this.lineItems = opts.lineItems.map(
        (val) => new ShipmentRateLineItemAllocation(val),
      );
    }
  }

  get isCostEstimateInvoiceTypes() {
    return this.lineItems.some(
      (allocation) => allocation.isCostEstimateInvoiceType,
    );
  }
}
